import React, { useState, useEffect } from 'react';
import { Grid, Typography, Container, Button, Card, CardContent, CardActions } from '@mui/material';

interface ClientData {
  name: string;
  date: string;
  count: number;
  address: string;
  dueDate: string;
  contactNumber: string;
  remarks: string;
}

const ClientDataPage: React.FC = () => {
  const [clientData, setClientData] = useState<ClientData[]>([]);
  const [message, setMessage] = useState<string>('');

  // Fetch data from the API
  const fetchClientData = async () => {
    try {
      const response = await fetch('http://localhost:3010/newdata');
      if (response.ok) {
        const data = await response.json();
        setClientData(data);
      } else {
        setMessage('Failed to fetch data. Please try again.');
      }
    } catch (error) {
      console.error('Error:', error);
      setMessage('An error occurred while fetching the data.');
    }
  };

  // Fetch data on component mount
  useEffect(() => {
    fetchClientData();
  }, []);

  return (
    <Container maxWidth="lg">
      <Typography variant="h4" gutterBottom align="center" mt={4}>
        Client Data
      </Typography>

      {/* Display message if any */}
      {message && (
        <Typography variant="body1" color="red" align="center" mt={2}>
          {message}
        </Typography>
      )}

      <Grid container spacing={3} mt={4}>
        {clientData.length > 0 ? (
          clientData.map((data, index) => (
            <Grid key={index}>
              <Card>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    {data.name}
                  </Typography>
                  <Typography variant="body1">
                    <strong>Date:</strong> {data.date}
                    <br />
                    <strong>Count:</strong> {data.count}
                    <br />
                    <strong>Address:</strong> {data.address}
                    <br />
                    <strong>Due Date:</strong> {data.dueDate}
                    <br />
                    <strong>Contact Number:</strong> {data.contactNumber}
                    <br />
                    <strong>Remarks:</strong> {data.remarks}
                  </Typography>
                </CardContent>
                <CardActions>
                  <Button size="small" color="primary">
                    More Info
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))
        ) : (
          <Typography variant="body1" align="center" mt={4}>
            No client data available.
          </Typography>
        )}
      </Grid>

      <Button
        variant="contained"
        color="primary"
        onClick={fetchClientData}
        fullWidth
        sx={{ mt: 4 }}
      >
        Refresh Data
      </Button>
    </Container>
  );
};

export default ClientDataPage;
